import { Box, Paper, Stack } from '@mui/material'

import { DEFAULT_PARTNER } from '@/constants/partners'
import { USER_ROLES } from '@/constants/userRoles'
import { useAuth } from '@/features/authentication/contexts/AuthContext'
import { SiteFinancialInfoForm } from '@/features/site/components/companyInfo/SiteFinancialInfoForm'
import type { Site } from '@/features/site/types/site'

import { SiteContacts } from './companyInfo/SiteContacts'
import { SiteInfoForm } from './companyInfo/SiteInfoForm'

interface SiteCompanyInfoViewProps {
  site: Site
}

export default function SiteCompanyInfoView({ site }: Readonly<SiteCompanyInfoViewProps>) {
  const { loggedInUser } = useAuth()

  const isAdministrator = loggedInUser?.role === USER_ROLES.ADMINISTRATORS.value
  const isResourceOwner = loggedInUser?.role === USER_ROLES.RESOURCE_OWNERS.value
  const isSiteDirectCustomer = site.partner?.partnerCode === DEFAULT_PARTNER.partnerCode

  return (
    <Box my={2} sx={{ width: '100%' }}>
      <Stack sx={{ flexDirection: 'row', width: '100%', gap: 2 }}>
        <Stack gap={2} sx={{ width: '100%' }}>
          <Paper sx={{ p: 3, height: 'fit-content', width: '100%' }}>
            <SiteInfoForm site={site} />
          </Paper>
          {(isAdministrator || isResourceOwner) && isSiteDirectCustomer && (
            <Paper sx={{ p: 3, height: 'fit-content', width: '100%' }}>
              <SiteFinancialInfoForm site={site} />
            </Paper>
          )}
        </Stack>

        <Paper sx={{ p: 3, height: 'fit-content', width: '100%' }}>
          <SiteContacts site={site} />
        </Paper>
      </Stack>
    </Box>
  )
}
